export const UPDATE_GLOBAL_FROM_TIME_TO_TIME = 'UPDATE_GLOBAL_FROM_TIME_TO_TIME';

export function updateGlobalFromTimeAndToTime(fromTime, toTime, presetDate) {
    return dispatch => {
        dispatch({
            type: UPDATE_GLOBAL_FROM_TIME_TO_TIME,
            globalFromTime: fromTime,
            globalToTime: toTime,
            presetDate: presetDate
        });
    }
}